import React from "react";
import { UserProfile, useClerk } from "@clerk/clerk-react";
import SchoolProfilePage from "../../components/school-profile-page";
import s from "./styles.module.scss";

// School icon for the nav
const SchoolIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
    <path d="M6 12v5c3 3 9 3 12 0v-5" />
  </svg>
);

// Sign out icon for the nav
const SignOutIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 25 25"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.5 8.5V6.5C10.5 5.96957 10.7107 5.46086 11.0858 5.08579C11.4609 4.71071 11.9696 4.5 12.5 4.5H19.5C20.0304 4.5 20.5391 4.71071 20.9142 5.08579C21.2893 5.46086 21.5 5.96957 21.5 6.5V18.5C21.5 19.0304 21.2893 19.5391 20.9142 19.9142C20.5391 20.2893 20.0304 20.5 19.5 20.5H12.5C11.9696 20.5 11.4609 20.2893 11.0858 19.9142C10.7107 19.5391 10.5 19.0304 10.5 18.5V16.5M15.5 12.5H3.5M3.5 12.5L6.5 9.5M3.5 12.5L6.5 15.5" />
  </svg>
);

// Sign out page content
const SignOutPage = () => {
  const { signOut } = useClerk();

  const handleSignOut = () => {
    signOut({ redirectUrl: "/" });
  };

  return (
    <div className={s.signOutPage}>
      <h2 className={s.signOutTitle}>Sign Out</h2>
      <p className={s.signOutText}>
        Click the button below to sign out of your Ocean account.
      </p>
      <button className={s.signOutButton} onClick={handleSignOut}>
        Sign out
      </button>
    </div>
  );
};

const UserProfilePage = () => {
  return (
    <div className={s.userProfileWrapper}>
      <div className={s.pageHeader}>
        <h1>User Profile</h1>
      </div>
      <UserProfile
        path="/user-profile"
        routing="path"
        appearance={{
          elements: {
            rootBox: s.cardBox,
            cardBox: s.cardBox,
            card: s.userProfileCard,
            scrollBox: s.scrollBox,
            navbar: s.userProfileNavbar,
            navbarButton: s.userProfileNavButton,
            navbarButtonActive: s.userProfileNavButtonActive,
            pageScrollBox: s.userProfileContent,
            formButtonPrimary: s.userProfileButton,
            headerTitle: s.hideElement,
            headerSubtitle: s.hideElement,
          },
        }}
        additionalOAuthScopes={{
          google: ["https://www.googleapis.com/auth/calendar.readonly"],
          outlook: ["calendars.read"],
        }}
      >
        <UserProfile.Page
          label="School"
          labelIcon={<SchoolIcon />}
          url="school"
        >
          <SchoolProfilePage />
        </UserProfile.Page>
        <UserProfile.Page
          label="Sign Out"
          labelIcon={<SignOutIcon />}
          url="sign-out"
        >
          <SignOutPage />
        </UserProfile.Page>
      </UserProfile>
    </div>
  );
};

export default UserProfilePage;
